import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";
import { VideoFootageForm } from "app/interfaces/videofootage-form.interface";

const videoFootagesSharedUrlApi = environment.videoFootagesSharedUrlApi;
const videoFootagesMySharedListUrlApi =
  environment.videoFootagesMySharedListUrlApi;

@Injectable()
export class SharedVideoFootageService {
  public user: UserForm;

  constructor(private http: HttpClient) {}

  getSharedVideoFootagesByIdUser(id: number) {
    return this.http
      .request("GET", `${videoFootagesSharedUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  shareVideoFootage(idUser: number, idVideoFootage: number) {
    const body = { id_user: idUser, id_videoFootage: idVideoFootage };
    return this.http
      .request("POST", `${videoFootagesSharedUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  getMySharedVideoFootagesListByIdUser(id: number) {
    return this.http
      .request("GET", `${videoFootagesMySharedListUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  deleteMySharedVideoFootageById(id: number) {
    return this.http
      .request("DELETE", `${videoFootagesSharedUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }
}
